import React from "react";
import { draftSizeKB } from "../../../Logic/Mail/size";
import { iEmail } from "../../../interfaces/emailModel";
import "../Workflow.scss";
type sizeIndicatorProps = {
    emailComposer: iEmail;
    embeddedAtachments: Array<{ id: string; name: string; mimeType: string; size: number }>;
};

function EmailSizeIndicator(props: sizeIndicatorProps) {
    const [totalSize, setTotalSize] = React.useState(0);
    let sizeLimitKB = parseInt(process.env.REACT_APP_MAIL_SIZE_LIMIT || "45", 10) * 1024;

    React.useEffect(() => {
        setTotalSize(draftSizeKB(props.emailComposer));
    }, [props.emailComposer, props.embeddedAtachments]);

    const formatSize = (val: number): string => {
        if (val >= 1024) {
            return (val / 1024).toFixed(2) + " MB";
        } else {
            return val.toFixed(2) + " KB";
        }
    };

    const getColorClass = (val: number): string => {
        if (val >= sizeLimitKB) {
            return "red";
        }
        if (val >= parseFloat(process.env.REACT_APP_MAIL_SIZE_WARNING ?? "20") * 1024) {
            return "orange";
        }
        return "green";
    };
    return (
        <div
            className={`emailSizeContainer ${getColorClass(totalSize)}`}
            title={
                getColorClass(totalSize) === "red"
                    ? `Email size cannot exceed ${process.env.REACT_APP_MAIL_SIZE_LIMIT ?? "45"} MB`
                    : "Email size indicator"
            }
        >
            <b>Email Size: </b>
            {formatSize(totalSize)} / {process.env.REACT_APP_MAIL_SIZE_LIMIT ?? "45"} MB
        </div>
    );
}

export default EmailSizeIndicator;
